module.exports = __webpack_public_path__ + "static/media/product (2).09605bf7.jpg";